// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CkDz","textarea":"styles_textarea__3p4ds"};